import React from 'react'

export default function StageIcon() {
    return (
        <svg 
            className='opacity-30'
            xmlns="http://www.w3.org/2000/svg"
            enableBackground="new 0 0 512 512"
            viewBox="0 0 512 512"
        >
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#5a5a5a"
                d="M361 76v30c0 8.399-6.599 15-15 15h-15V76c0-8.401-6.599-15-15-15H196c-8.401 0-15 6.599-15 15v45h-15c-8.401 0-15-6.601-15-15V76c0-24.901 20.099-45 45-45h120c24.901 0 45 20.099 45 45z"
                data-original="#5a5a5a"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#444"
                d="M316 61h-60V31h60c24.901 0 45 20.099 45 45v30c0 8.399-6.599 15-15 15h-15V76c0-8.401-6.599-15-15-15z"
                data-original="#444444"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#5a5a5a"
                d="M512 106v330c0 24.899-20.099 45-45 45H45c-24.901 0-45-20.101-45-45V106c0-4.2 1.8-7.8 4.501-10.501L81 267.7h350l76.5-172.202C510.2 98.2 512 101.8 512 106z"
                data-original="#5a5a5a"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#444"
                d="M512 106v330c0 24.899-20.099 45-45 45H256V267.7h175l76.5-172.202C510.2 98.2 512 101.8 512 106z"
                data-original="#444444"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#6e6e6e"
                d="M507.499 95.499L461 267.7c-5.4 19.799-23.099 33.3-43.5 33.3H94.501C74.099 301 56.4 287.5 51 267.7L4.501 95.499C7.2 92.8 10.8 91 15 91h482c4.2 0 7.8 1.8 10.499 4.499z"
                data-original="#6e6e6e"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#5a5a5a"
                d="M507.499 95.499L461 267.7c-5.4 19.799-23.099 33.3-43.5 33.3H256V91h241c4.2 0 7.8 1.8 10.499 4.499z"
                data-original="#5a5a5a"
            ></path>
            <path 
                xmlns="http://www.w3.org/2000/svg"
                fill="#ffd400"
                d="M316 256H196c-8.401 0-15 6.599-15 15v60c0 8.399 6.599 15 15 15h120c8.401 0 15-6.601 15-15v-60c0-8.401-6.599-15-15-15z"
                data-original="#ffd400"
            ></path>
            <path className='animate-pulse'
                xmlns="http://www.w3.org/2000/svg"
                fill="#fdbf00"
                d="M331 271v60c0 8.399-6.599 15-15 15h-60v-90h60c8.401 0 15 6.599 15 15z"
                data-original="#fdbf00"
            ></path>
        </svg>
    )
}
